import Icon from '../components/Icon.vue'

Icon.register({
  skiing: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M432 96c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM505 452.1c9.3 9.3 9.3 24.5 0 33.8-17 17-39.8 26-63 26-12.6 0-25.2-2.6-37.1-8.1l-391.9-202.5c-11.8-6-16.4-20.5-10.3-32.3 6.1-11.8 20.6-16.3 32.3-10.3l197.9 102.3 45.9-68.8-75.1-75.2c-14.3-14.4-20.6-34.5-17.7-54.4l107 53.1 40.4 40.5c16.2 16.1 18.7 41.6 6 60.6l-49.2 73.8 135.8 70.2c14.6 6.7 33 3.4 45.1-8.7 9.3-9.4 24.5-9.4 33.9 0zM120 91.6l-26.2-23c-2.2-1.9-2.4-5.2-0.5-7.4 1.3-1.5 3.2-2.1 5-1.7l34.4 7h0.2l11.1-21.7c13.7 7 21.2 21.1 20.9 35.6l62.5 31 81.2-32.5c43.6-17.4 76.4 15 84.5 39.2l17.1 51.2 52.1 26.1c15.8 7.9 22.2 27.1 14.3 42.9-7.9 15.8-27 22.2-42.9 14.3l-58.1-29c-11.4-5.7-20-15.6-24-27.7l-6.4-19.1-32.4 13-114.5-56.8c0.1-0.1 0.1-0.2 0.2-0.3l-47.2-23.4c-11.6 9.7-28.4 12.1-42.8 4.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/skiing.js
// module id = 1899
// module chunks = 0